export const defaultProps = {
    backgroundImage: 'https://placehold.co/1850x920/png',
    title: 'Unsubscribed by accident',
    copy: 'No worries! Click the link below to undo it:',
    email: undefined,
    buttonText: 'Re-Subscribe',
};
